import { render, staticRenderFns } from "./ExhibitionClue.vue?vue&type=template&id=05f0127c&scoped=true&"
import script from "./ExhibitionClue.vue?vue&type=script&lang=js&"
export * from "./ExhibitionClue.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionClue.vue?vue&type=style&index=0&id=05f0127c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f0127c",
  null
  
)

export default component.exports